/**
 * 分组讨论：横幅（提示去自己的小组 / 回主房间）与主持人的分组面板。
 */

import { useState } from 'react'

import { hasPerm, MaxGroups, Perm } from '../lib/protocol'
import { useRoomStore } from '../stores/roomStore'
import { IcMegaphone } from './Icons'

/** 分组横幅：告诉当前用户该去哪。没在分组中时不渲染。 */
export function GroupBanner({ onSwitchRoom }: { onSwitchRoom?: (roomId: number) => void }) {
  const groups = useRoomStore((s) => s.groups)
  const myGroup = useRoomStore((s) => s.myGroup)
  const closed = useRoomStore((s) => s.groupClosed)
  const notice = useRoomStore((s) => s.groupNotice)
  const clear = useRoomStore((s) => s.clearGroupState)

  if (closed !== null) {
    return (
      <div className="group-bar back">
        <span>分组讨论已结束</span>
        <button className="primary" onClick={() => { clear(); onSwitchRoom?.(closed) }}>
          回到主教室
        </button>
      </div>
    )
  }
  if (notice) {
    return (
      <div className="group-bar notice">
        <span className="gb-notice"><IcMegaphone size={14} /> {notice}</span>
        <button onClick={() => useRoomStore.setState({ groupNotice: null })}>知道了</button>
      </div>
    )
  }
  if (myGroup) {
    return (
      <div className="group-bar">
        <span>分组讨论已开始，你在「{myGroup.name}」</span>
        <button className="primary" onClick={() => onSwitchRoom?.(myGroup.roomId)}>
          进入我的小组
        </button>
      </div>
    )
  }
  if (groups.length > 0) {
    // 主持人不属于任何组，可以挑一个组进去巡视。
    return (
      <div className="group-bar">
        <span>分组讨论进行中（{groups.length} 组）</span>
        {groups.map((g) => (
          <button key={g.index} onClick={() => onSwitchRoom?.(g.roomId)}>
            去{g.name}
          </button>
        ))}
      </div>
    )
  }
  return null
}

/** 主持人的分组控制：开启、通知、结束。 */
export function GroupCompose({ onClose }: { onClose: () => void }) {
  const groups = useRoomStore((s) => s.groups)
  const open = useRoomStore((s) => s.openGroups)
  const close = useRoomStore((s) => s.closeGroups)
  const notify = useRoomStore((s) => s.notifyGroups)
  const members = useRoomStore((s) => s.members)
  const selfId = useRoomStore((s) => s.selfId)
  const [count, setCount] = useState(2)
  const [text, setText] = useState('')

  // 能被分组的人数：主持人不参与分组。
  const splittable = [...members.values()].filter((m) => m.id !== selfId && !hasPerm(m.prop, Perm.Op)).length
  const running = groups.length > 0

  return (
    <div className="dlg-mask" onClick={onClose}>
      <div className="dlg narrow group-dlg" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="分组讨论">
        <h3>分组讨论</h3>
        {running ? (
          <>
            <p className="group-sum">正在进行：{groups.length} 组</p>
            <ul className="group-list">
              {groups.map((g) => (
                <li key={g.index}>
                  <span className="group-name">{g.name}</span>
                  <span className="group-n">{g.members.length} 人</span>
                </li>
              ))}
            </ul>
            <label className="group-lbl">
              给各组发通知
              <span className="group-row">
                <input value={text} maxLength={200} placeholder="例如：还有 2 分钟" onChange={(e) => setText(e.target.value)} />
                <button disabled={!text.trim()} onClick={() => { notify(text.trim()); setText('') }}>发送</button>
              </span>
            </label>
            <div className="dlg-foot">
              <button onClick={onClose}>关闭</button>
              <button className="primary" onClick={() => { close(); onClose() }}>结束分组讨论</button>
            </div>
          </>
        ) : (
          <>
            <p className="group-sum">当前可分组 {splittable} 人（主持人不参与分组，可在各组间巡视）</p>
            <label className="group-lbl">
              分成几组
              <select value={count} onChange={(e) => setCount(Number(e.target.value))}>
                {Array.from({ length: MaxGroups - 1 }, (_, i) => i + 2).map((n) => (
                  <option key={n} value={n}>{n} 组</option>
                ))}
              </select>
            </label>
            <p className="group-tip">按在场成员平均分配。分组期间各组的白板与聊天互相独立。</p>
            <div className="dlg-foot">
              <button onClick={onClose}>取消</button>
              <button className="primary" disabled={splittable < 2} onClick={() => { open(count); onClose() }}>
                开始分组
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
